(function() { window.GUID_3b012e62_11f7_4213_a39e_c9bfd2152637 = { getGuid: function() { return "3b012e62-11f7-4213-a39e-c9bfd2152637"; } }; })();
var RegistrationStatus;
(function (RegistrationStatus) {
    BindElements();
    function BindElements() {
        var result = $('#DivisionGroupResult');
        $('.BtnDivisionGroup').on('click', function (e) {
            e.preventDefault();
            var divgrid = $(this).data('divgrid');
            RefreshDivisionGroup(divgrid);
        });
        function RefreshDivisionGroup(divGrId) {
            var data = {
                divisionGroupId: divGrId
            };
            CompuSport.Ajax.Get(CSParameters.BaseUrl + 'RegistrationStatus/RefreshDivisionGroup/' + CSParameters.SportEventId, data, function (response) {
                result[0].innerHTML = response;
                $.removeCookie('lastRegStatusDivGroupId' + CSParameters.SportEventId, { path: '/' });
                $.cookie('lastRegStatusDivGroupId' + CSParameters.SportEventId, divGrId, { expires: 365, path: '/' });
            });
        }
        if (result.length > 0) {
            var lastRegStatusDivGroupId = $.cookie('lastRegStatusDivGroupId' + CSParameters.SportEventId);
            if (lastRegStatusDivGroupId != null) {
                RefreshDivisionGroup(lastRegStatusDivGroupId);
            }
            else {
                $('#MessageWhenEmpty').show();
            }
        }
    }
    RegistrationStatus.BindElements = BindElements;
})(RegistrationStatus || (RegistrationStatus = {}));

//# sourceMappingURL=RegistrationStatus.js.map
